export const dataLibB = [{
  word: 'bak',
  partOfSpeech: 'N',
  definition: ['river crab'],
  egSentenceKw: 'Yo ka tjébé bak.',
  egSentenceEn: 'They\'re catching crabs.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèf',
  partOfSpeech: 'N',
  definition: ['cow', 'cattle'],
  egSentenceKw: 'Bèf-la kwazé jaden mwen.',
  egSentenceEn: 'The cow destroyed my garden.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. bouef]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bonbon',
  partOfSpeech: 'N',
  definition: ['cake'],
  egSentenceKw: 'Yo fè on bonbon pou nòs mwen.',
  egSentenceEn: 'They made a cake for my wedding.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. bonbon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'blé',
  partOfSpeech: 'ADJ',
  definition: ['blue'],
  egSentenceKw: 'I ka pòté on chimiz blé.',
  egSentenceEn: 'He is wearing a blue shirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. bleu]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'blan',
  partOfSpeech: 'ADJ',
  definition: ['white'],
  egSentenceKw: 'Kay-la té pentiwé blan.',
  egSentenceEn: 'The house was painted white.',
  synonym: [null],
  antonym: 'nwè',
  etymology: '[< Fr. blanc]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bwaslé',
  partOfSpeech: 'N',
  definition: ['bracelet'],
  egSentenceKw: 'Tifi-a ni on bwaslé nèf.',
  egSentenceEn: 'The girl has a new bracelet.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. bracelet]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bag',
  partOfSpeech: 'N',
  definition: ['ring'],
  egSentenceKw: 'Mwen achté on bag lò',
  egSentenceEn: 'I bought a gold ring.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. bague]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'boug',
  partOfSpeech: 'N',
  definition: ['fellow', 'guy'],
  egSentenceKw: 'Sa boug-la ka di la-a?',
  egSentenceEn: 'What is that guy saying?',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bagay',
  partOfSpeech: 'N',
  definition: ['thing'],
  egSentenceKw: 'Koté i jwenn bagay sala?',
  egSentenceEn: 'Where did he find that thing?',
  synonym: ['ba\'ay', 'bagaj'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bak',
  partOfSpeech: 'INTERJ',
  definition: ['to reverse', 'to back (up)'],
  egSentenceKw: 'Yo tout bak dèyè lè yo wè fizi mwen.',
  egSentenceEn: 'They all backed up when they saw my gun.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. back]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'baka',
  partOfSpeech: 'N',
  definition: ['backer', 'supporter'],
  egSentenceKw: 'Yo pwen lavantay asou mwen paski mwen pa té ni pyès baka.',
  egSentenceEn: 'They took advantage of me because I didn\'t have any supporters.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. backer]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'banjo',
  partOfSpeech: 'N',
  definition: ['banjo'],
  egSentenceKw: 'I ka jwé banndjo-a.',
  egSentenceEn: 'He\'s playing the banjo.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. banjo]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'banjo',
  partOfSpeech: 'N',
  definition: ['skipjack tuna'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bék',
  partOfSpeech: 'N',
  definition: ['bake: flat bread cooked on a hot plate'],
  egSentenceKw: 'Bék cho bon épi bè.',
  egSentenceEn: 'Hot bakes are good with butter.',
  synonym: ['roti'],
  antonym: [null],
  etymology: '[< Eng. bake]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèlibann',
  partOfSpeech: 'N',
  definition: ['cinch', 'girth'],
  egSentenceKw: 'I séwé bèlibann-an anba bouden chouval-la.',
  egSentenceEn: 'He tightened the cinch under the horse\'s belly.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. belly band]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bésin',
  partOfSpeech: 'N',
  definition: ['basin'],
  egSentenceKw: 'Genyen an bésin ban mwen pou mwen sa pentwi fawin fwans mwen.',
  egSentenceEn: 'Get a basin for me to knead my flour in.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. basin]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bol',
  partOfSpeech: 'N',
  definition: ['ball'],
  egSentenceKw: 'I vowé bol-la.',
  egSentenceEn: 'He threw the ball.',
  synonym: ['krikèt'],
  antonym: [null],
  etymology: '[< Eng. bowl]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bol',
  partOfSpeech: 'N',
  definition: ['cricket'],
  egSentenceKw: 'Lè nou té tibway, nou toujou té ka jwé bol apwé lékòl.',
  egSentenceEn: 'When we were boys, we always used to play cricket after school.',
  synonym: ['krikèt'],
  antonym: [null],
  etymology: '[< Eng. bowl]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bway',
  partOfSpeech: 'N',
  definition: ['boy', 'man', 'guy', 'male'],
  egSentenceKw: 'É bway, koté ou ka alé?',
  egSentenceEn: 'Hey guy, where are you going?',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. boy]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bwèy',
  partOfSpeech: 'N',
  definition: ['boy', 'man', 'guy', 'male'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. boy]',
  dialect: '🇱🇨',
  variant: ['bway'],
}, {
  word: 'bwè',
  partOfSpeech: 'V',
  definition: ['to drink'],
  egSentenceKw: 'Mwen enmen bwè dlo fwèt lè ng\'a santi cho.',
  egSentenceEn: 'I like to drink cold water when I am feeling hot.',
  synonym: ['bwason', 'gobé', 'gòg'],
  antonym: [null],
  etymology: '[< Fr. boire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bwè',
  partOfSpeech: 'V',
  definition: ['to take in completely what a person is saying', 'to eavesdrop'],
  egSentenceKw: 'Ou ka bwè sa moun-an ka di-a, mé i pa ka palé ba\'w.',
  egSentenceEn: 'You\'re taking in everything the person is saying, but he\'s not talking to you.',
  synonym: ['gobé'],
  antonym: [null],
  etymology: '[< Fr. boire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bonmaten',
  partOfSpeech: 'N',
  definition: ['morning'],
  egSentenceKw: 'Nou ka mouté toulé bonmaten.',
  egSentenceEn: 'We go up every morning.',
  synonym: [null],
  antonym: ['òswè'],
  etymology: '[< Fr. bon matin]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bay',
  partOfSpeech: 'V',
  definition: ['to give'],
  egSentenceKw: 'Yo bay Pita lajan-an.',
  egSentenceEn: 'They gave Peter the money.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['ba', 'ban'],
}, {
  word: 'bay',
  partOfSpeech: 'PREP',
  definition: ['for', 'on the behalf of'],
  egSentenceKw: 'Mwen kay achté on motoka bay zòt.',
  egSentenceEn: 'I am going to buy a car for you all.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['ba', 'ban'],
}, {
  word: 'bò',
  partOfSpeech: 'N',
  definition: ['side'],
  egSentenceKw: 'Nou wè\'y lòt bò- a.',
  egSentenceEn: 'We saw him on the other side.',
  synonym: ['alafen di', 'apipwé', 'avèwdi', 'fasad', 'koté', 'owon', 'sayd', 'vèò'],
  antonym: [null],
  etymology: '[< Eng. bord]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bò',
  partOfSpeech: 'PREP',
  definition: ['by', 'alongside', 'beside', 'near', 'next to'],
  egSentenceKw: 'I vini bò kannòt-la.',
  egSentenceEn: 'He came near the boat.',
  synonym: ['fasad', 'koté', 'sayd'],
  antonym: ['lwen'],
  etymology: '[< Eng. bord]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bò',
  partOfSpeech: 'PREP',
  definition: ['by', 'alongside', 'beside', 'near', 'next to'],
  egSentenceKw: 'I vini bò kannòt-la.',
  egSentenceEn: 'He came near the boat.',
  synonym: ['fasad', 'koté', 'sayd'],
  antonym: ['lwen'],
  etymology: '[< Eng. bord]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bòdaj',
  partOfSpeech: 'PREP',
  definition: ['alongside', 'beside', 'next to'],
  egSentenceKw: 'Nonm sou-a kouché bòdaj chimen-an.',
  egSentenceEn: 'The drunk man lay down beside the road.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. bordage]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bòdaj',
  partOfSpeech: 'PREP',
  definition: ['bank (of a river)', 'edge'],
  egSentenceKw: 'I wèsté asou bòdaj lawivyè-a pou péché.',
  egSentenceEn: 'He settled on the side of the river to fish.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. bordage]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bondyé',
  partOfSpeech: 'N',
  definition: ['God'],
  egSentenceKw: 'Bondyé ka potjiwé ban nou.',
  egSentenceEn: 'God provides for us.',
  synonym: ['Bondous'],
  antonym: [null],
  etymology: '[< Eng. bon Dieu]',
  dialect: '🇱🇨',
  variant: ['Dyé'],
}, {
  word: 'bondyé',
  partOfSpeech: 'INTERJ',
  definition: ['Good Lord!'],
  egSentenceKw: 'Bondyé ka potjiwé ban nou.',
  egSentenceEn: 'Good Lord! What happened to you?',
  synonym: ['Bondous'],
  antonym: [null],
  etymology: '[< Eng. bon Dieu]',
  dialect: '🇱🇨',
  variant: ['Dyé'],
}, {
  word: 'bèt',
  partOfSpeech: 'N',
  definition: ['animal', 'beast'],
  egSentenceKw: 'Bèt-la alé avan mwen wè sa i té yé.',
  egSentenceEn: 'The animal got away before I could see what it was.',
  synonym: ['zannimo'],
  antonym: [null],
  etymology: '[< Eng. bête]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèt',
  partOfSpeech: 'N',
  definition: ['bug', 'insect'],
  egSentenceKw: 'La té ni tout sòt kalté bèt an jaden-an.',
  egSentenceEn: 'There were all kinds of bugs in the garden.',
  synonym: ['zannimo'],
  antonym: [null],
  etymology: '[< Eng. bête]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèt',
  partOfSpeech: 'ADJ',
  definition: ['stupid', 'foolish (in reference to a woman)'],
  egSentenceKw: 'Fanm-lan té bèt an chay.',
  egSentenceEn: 'The woman was very foolish.',
  synonym: ['kouyon'],
  antonym: [null],
  etymology: '[< Eng. sòt]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ban',
  partOfSpeech: 'N',
  definition: ['bench'],
  egSentenceKw: 'I mété chapo-a asou ban-an.',
  egSentenceEn: 'He put his hat on the bench.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr.banc]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ban',
  partOfSpeech: 'V',
  definition: ['to give'],
  egSentenceKw: 'Ban mwen an ti bo.',
  egSentenceEn: 'Give me a little kiss.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['ba', 'bay'],
}, {
  word: 'ban',
  partOfSpeech: 'V',
  definition: ['to let', 'to allow', 'to permit'],
  egSentenceKw: 'Ban mwen di\'w yon bagay.',
  egSentenceEn: 'Let me tell you something.',
  synonym: ['kité', 'pèwmité'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['ba', 'bay'],
}, {
  word: 'ban',
  partOfSpeech: 'PREP',
  definition: ['for'],
  egSentenceKw: 'Fè sa ban mwen souplé.',
  egSentenceEn: 'Do that for me, please.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['pou'],
}, {
  word: 'benyen',
  partOfSpeech: 'V',
  definition: ['to bathe'],
  egSentenceKw: 'Yo vlé benyen atjòlman.',
  egSentenceEn: 'They want to bathe now.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'benyen',
  partOfSpeech: 'V',
  definition: ['to have an abundance', 'to have a lot of something', 'to be full of'],
  egSentenceKw: 'Plas-la ni tizing tè mé anba\'y té benyen kayè.',
  egSentenceEn: 'The place had a little soil but under it there were a lot of rocks.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. baigner]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bon',
  partOfSpeech: 'ADJ',
  definition: ['good'],
  egSentenceKw: 'Ou sa anployé nonm sala; i ka fè bon twavay.',
  egSentenceEn: 'You can employ that man; he does good work.',
  synonym: [null],
  antonym: ['bwital', 'méchan', 'modi', 'mové', 'séléwa', 'vyé'],
  etymology: '[< Fr. bon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bon',
  partOfSpeech: 'INTERJ',
  definition: ['good', 'okay', 'well'],
  egSentenceKw: 'Bon, sé sa nou kay fè.',
  egSentenceEn: 'Okay, that\'s what we\'ll do.',
  synonym: [null],
  antonym: ['méchan', 'modi', 'mové', 'séléwa', 'vyé'],
  etymology: '[< Fr. bon]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèl',
  partOfSpeech: 'ADJ',
  definition: ['pretty', 'beautiful'],
  egSentenceKw: 'Kay-la té bèl.',
  egSentenceEn: 'The house was beautiful.',
  synonym: ['joli'],
  antonym: ['lèd'],
  etymology: '[< Fr. belle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'bèl',
  partOfSpeech: 'ADJ',
  definition: ['serious', 'good', '(in an ironic sense)'],
  egSentenceKw: 'Yo bay misyé-a an bèl chalè.',
  egSentenceEn: 'They gave the man a good beating.',
  synonym: ['joli'],
  antonym: ['lèd'],
  etymology: '[< Fr. belle]',
  dialect: '🇱🇨',
  variant: [null],
},
];
